/**
 * Yotpo Rating Slot v3 — for lazy-loaded Yotpo widgets
 * ----------------------------------------------------
 * Changes vs v2:
 *  - NO timeout on finding the widget. Yotpo on this theme renders
 *    late/lazily, so we poll every 500ms until it exists — however long
 *    that takes. The check is one querySelector, so cost is negligible.
 *  - Injects a <span>, not a <button> — the sticky-bar slot sits inside
 *    an <a> tag, and a button inside a link is invalid + hijacks clicks.
 *  - After first fill, keeps watching for NEW slots for 60s more
 *    (sticky bars / drawers that mount on scroll).
 *  - Auto re-checks if Yotpo re-renders with different numbers.
 */

(function () {
  function log(msg, extra) {
    try { console.log('[RatingSlot] ' + msg, extra || ''); } catch (e) {}
  }

  /* ---- read score + count from rendered widget ----------------- */
  function readYotpoRating() {
    var btn = document.querySelector('.yotpo-sr-bottom-line-summary');
    if (!btn) return null;

    var score = null, count = null;
    var scoreEl = btn.querySelector('.yotpo-sr-bottom-line-score');
    var countEl = btn.querySelector('.yotpo-sr-bottom-line-text');
    if (scoreEl) score = parseFloat(scoreEl.textContent.trim());
    if (countEl) {
      var cm = countEl.textContent.match(/\d+/);
      if (cm) count = parseInt(cm[0], 10);
    }
    if (!score || count === null) {
      var m = (btn.getAttribute('aria-label') || '').match(/([\d.]+)\s*out\s*5?.*?(\d+)\s*reviews/i);
      if (m) { score = score || parseFloat(m[1]); count = count === null ? parseInt(m[2], 10) : count; }
    }
    return score ? { score: score, count: count || 0 } : null;
  }

  /* ---- build markup (span-only, safe inside <a>) ---------------- */
  function starSVG() {
    return '<svg viewBox="0 0 18 18" width="15" height="15" aria-hidden="true" style="margin-right:3.5px;vertical-align:middle;">' +
      '<path d="M9 14.118L14.562 17.475L13.086 11.148L18 6.891L11.529 6.342L9 0.375L6.471 6.342L0 6.891L4.914 11.148L3.438 17.475L9 14.118Z" ' +
      'fill="rgba(255,210,0,1)" stroke="rgba(255,210,0,1)"></path></svg>';
  }

  function ratingHTML(data) {
    var stars = starSVG() + starSVG() + starSVG() + starSVG() + starSVG();
    return '<span class="custom-rating" role="img" aria-label="' + data.score + ' out of 5 stars, ' + data.count + ' reviews" ' +
      'style="display:inline-flex;align-items:center;font-family:\'Work Sans\',sans-serif;line-height:1;">' +
        '<span style="display:inline-flex;align-items:center;">' + stars + '</span>' +
        '<span style="color:rgb(255,210,0);font-size:14px;margin:0 8px 0 4px;padding-top:2px;">' + data.score + '</span>' +
        '<span style="height:11px;border-right:1px solid #2c2c2c;margin-right:8px;"></span>' +
        '<span style="color:#2c2c2c;font-size:14px;padding-top:2px;">' + data.count + ' Reviews</span>' +
      '</span>';
  }

  function fillSlots(data) {
    var slots = document.querySelectorAll('.js-rating-slot:not([data-filled])');
    if (!slots.length) return 0;
    var html = ratingHTML(data);
    slots.forEach(function (s) {
      s.innerHTML = html;
      s.setAttribute('data-filled', '1');
    });
    return slots.length;
  }

  /* ---- phase 1: wait forever for the lazy widget ---------------- */
  var announced = false;
  var waitTimer = setInterval(function () {
    var data = readYotpoRating();
    if (!data) {
      if (!announced) { log('Waiting for Yotpo widget (lazy load)...'); announced = true; }
      return;
    }
    clearInterval(waitTimer);
    log('Yotpo found: ' + data.score + ' / ' + data.count + ' reviews');
    var n = fillSlots(data);
    log('Filled ' + n + ' slot(s).');

    /* ---- phase 2: keep filling late-mounted slots for 60s ------- */
    var extraTicks = 0;
    var lateTimer = setInterval(function () {
      extraTicks++;
      // re-read in case Yotpo re-rendered (variant change etc.)
      var fresh = readYotpoRating() || data;
      var filled = fillSlots(fresh);
      if (filled) log('Filled ' + filled + ' late slot(s).');
      if (extraTicks >= 120) clearInterval(lateTimer); // 120 x 500ms = 60s
    }, 500);
  }, 500);
})();